export const getAuthPayload = (response) => response?.data ?? response ?? {};

export const getAuthCookieOptions = () => ({
  expires: 365,
  sameSite: "strict",
  secure:
    typeof window !== "undefined" && window.location?.protocol === "https:",
  path: "/",
});

export const safeParseJson = (value, fallback = null) => {
  if (!value || value === "undefined") {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (_) {
    return fallback;
  }
};

export const getAuthenticatedUser = (authUser) => authUser?.user ?? authUser ?? null;

export const getUserFlag = (authUser, defaultFlag = "user") => {
  const user = getAuthenticatedUser(authUser);
  return user?.flag ?? defaultFlag;
};

export const normalizePermissions = (permissions) => {
  if (!Array.isArray(permissions)) {
    return [];
  }

  return permissions
    .map((permission) =>
      typeof permission === "string" ? permission : permission?.name
    )
    .filter(Boolean);
};

export const normalizeAuthResponse = (response) => {
  const payload = getAuthPayload(response);
  const user = payload.user ?? payload.Admin ?? payload.admin ?? null;

  return {
    userData: {
      token: payload.token,
      user,
    },
    permissions: normalizePermissions(payload.Permissions ?? payload.permissions),
  };
};

export const isAdminUser = (authUser) => getUserFlag(authUser) === "admin";

export const isOwnerRole = (role) => {
  const numericRole =
    role !== null && role !== undefined && role !== "" ? Number(role) : NaN;

  return role === "Owner" || numericRole === 0;
};

export const isClientOwner = (authUser) => {
  const user = getAuthenticatedUser(authUser);
  return user?.flag !== "admin" && isOwnerRole(user?.role);
};

export const hasPermission = (permissions, permission, authUser = null) => {
  if (isOwnerRole(getAuthenticatedUser(authUser)?.role)) {
    return true;
  }

  return Array.isArray(permissions) && permissions.includes(permission);
};

export const hasAllPermissions = (permissions, requiredPermissions, authUser = null) => {
  if (!requiredPermissions?.length || isOwnerRole(getAuthenticatedUser(authUser)?.role)) {
    return true;
  }

  return requiredPermissions.every((permission) =>
    Array.isArray(permissions) && permissions.includes(permission)
  );
};
